(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('ChatController', ChatController);
    ChatController.$inject = [
        'chat',
        'genericDataService',
        'preferences',
        '$scope',
        '$stateParams',
        '$filter',
        'fleet',
        '$timeout'
    ];

    function ChatController(chat, genericDataService, preferences, $scope, $stateParams, $filter, fleet, $timeout) {
        var vm = this;
        vm.chatSideBar = chatSideBar;
        vm.chat = chat;
        vm.preferences = preferences.prefs;
        vm.operators = null;
        vm.selectedOperatorId = null;
        vm.selectedOperator = null;
        vm.operatorMessages = null;
        vm.writtenMessage = null;
        vm.forceGlue = true;

        vm.selectOperator = selectOperator;
        vm.chatBoxKeyPress = chatBoxKeyPress;
        vm.getOperatorStateColor = getOperatorStateColor;

        vm.operarioListControl = {};


        //Init
        (function () {
            genericDataService.getOperarios().then(function (data) {
                vm.operators = data; 
                if ($stateParams.id != null && $stateParams.id !== '00000000-0000-0000-0000-000000000000') {
                    var op = $filter('filter')(vm.operators, {'id': $stateParams.id});
                    if(op){ selectOperator(op[0]); }
                }
            });
            /*
            genericDataService.getOperarios().then(function (data) {
                vm.operators = data; 
                chat.loadChat().then(function (messages) {
                    updateNewMessagesList();
                    
                });
            });*/
        })();


        $scope.$on('heartbeat-pulse', function (event, args) {
            if (vm.selectedOperatorId) {
                markAsReadForOperator(vm.selectedOperatorId);
            }
        });

        ///////// IMPLEMENTATIONS ////////

        function chatSideBar() {
            vm.showChat = !vm.showChat;
        }

        function selectOperator(operator){
            vm.forceGlue = true;
            vm.selectedOperatorId = operator.id;
            vm.selectedOperator = operator;
            markAsReadForOperator(operator.id);

            vm.operarioListControl.goTo(indexOf(vm.selectedOperator));

            $timeout(function(){
                document.getElementById('chat-input').focus();
            }, 0);
        }

        function chatBoxKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                vm.chat.sendMessage(vm.selectedOperatorId, vm.writtenMessage);
                vm.writtenMessage = null;
            }
        }
        function indexOf(item){
            
            var opOnline = $filter('filter')(vm.operators, {nombre:vm.operatorFilter,operatorStateId:'!100'});
            opOnline = $filter('orderBy')(opOnline, 'nombre');
            
            var opOffline = $filter('filter')(vm.operators, {nombre:vm.operatorFilter,operatorStateId:'100'});
            opOffline = $filter('orderBy')(opOffline, 'nombre');

            var index = -1;

            if(item.operatorStateId !== 100){
                index = opOnline.indexOf(item);
            }else{
                index = opOnline.length + opOffline.indexOf(item);
            }
            
            return index;
        }



        ////PRIVATE FUNCTIONS////

        function markAsReadForOperator(id) {
            var messages = vm.chat.messages;
            if(messages == null) { return; }
            var to = messages.length || 0;
            var ids = [];
            for (var i = 0; i < to; i++) {
                if (messages[i].direction === 'IN' &&
                    messages[i].operatorId === id &&
                    messages[i].readTime === null) {
                    ids.push(messages[i].id);
                }
            }
            if (ids.length > 0) {
                chat.markAsRead(ids);
            }
        }
/*
        function updateNewMessagesList() {
            var messages = vm.chat.messages;
            var to = messages.length || 0;
            var processedOpMessages = {};
            for (var i = 0; i < to; i++) {
                if (messages[i].direction === 'IN') {
                    var processedOp = processedOpMessages[messages[i].operatorId] || { unread:0 , lastTime: null};
                    if (messages[i].readTime === null) {
                        processedOp.unread = processedOp.unread + 1;
                    }
                    if ((processedOp.lastTime === null) || (processedOp.lastTime < messages[i].sentTime)) {
                        processedOp.lastTime = messages[i].sentTime;
                    }
                    processedOpMessages[messages[i].operatorId] = processedOp;
                }
            }
            vm.operatorMessages = processedOpMessages;
        }*/

        
        function getOperatorStateColor(opId){
            if(!fleet.mapData) {return;}
            var op = $filter('filter')(fleet.mapData.fleet, {'operatorId': opId});
            if(op.length <= 0){ return vm.preferences.getStateColor(100); }

            return vm.preferences.getStateColor(op[0].operatorStateId);
        }
        

    }

})();